import * as React from "../_snowpack/pkg/react.js";
import {HStack, Input} from "../_snowpack/pkg/@chakra-ui/react.js";
import {DurationCtx} from "./store.js";
import {Entry} from "./Entry.js";
export const DurationRow = ({
  choices,
  unit
}) => {
  const state = React.useContext(DurationCtx);
  const onInputChange = (event) => {
    const val = event?.target?.value;
    if (typeof val !== "string") {
      return;
    }
    if (val === "") {
      state.setDuration(null);
      return;
    }
    const parsed = parseInt(val);
    if (isNaN(parsed) || parsed < 1) {
      return;
    }
    state.setDuration({[unit]: parsed});
  };
  const inputValue = state.duration?.[unit] || "";
  return /* @__PURE__ */ React.createElement(HStack, {
    justify: "space-between",
    width: "100%",
    role: "row"
  }, choices.map((num) => /* @__PURE__ */ React.createElement(Entry, {
    value: {[unit]: num},
    key: unit + num
  })), /* @__PURE__ */ React.createElement(Input, {
    size: "xs",
    maxWidth: "3rem",
    onChange: onInputChange,
    value: inputValue
  }));
};
